import React, { useEffect, useState } from "react";
import { decodeHtml } from "../../../../assests/extention/commonfunction";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../../../redux/api";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { ModalBody } from "reactstrap";
import { updateProfile } from "../../../../redux/profile/action";
import { getIndustry, getSkillswithCategory } from "../../../../redux/categary/action";
import { titlevalidation } from "../../../Common/commonvalidation";
import { isDuplicateSkill } from "../../../../utils/skillUtils";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";

const ProfileModelCategoerySubcategory = ({
  formData,
  setFormData,
  edittype,
  setCatsubcat,
}) => {
  const dispatch = useDispatch();

  const industrylist = useSelector(
    ({ categary: { industrylist } }) => industrylist
  );

  const [selectedIndustries, setSelectedIndustries] = useState(
    formData?.industries || []
  );
  const [selectedCategories, setSelectedCategories] = useState(
    formData?.categories || []
  );
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subcategoryOptions, setSubcategoryOptions] = useState({});
  const [validation, setValidation] = useState(false);
  const [popularSkills, setPopularSkills] = useState([]);
  const [allSkills, setAllSkills] = useState([]);
  const [selectSkills, setSelectSkills] = useState(null);
  const [selectedSkills, setSelectedSkills] = useState(formData?.skills || []);
  const [manualSkill, setManualSkill] = useState("");
  const [addmanual, setAddmanual] = useState(false);
  const [skillValidation, setSkillValidation] = useState(false);

  // Fetch industries initially
  useEffect(() => {
    dispatch(getIndustry());
  }, [dispatch]);

  // Restore all options when formData has selections
  useEffect(() => {
    if (formData?.industries?.length > 0) {
      fetchCategories(formData.industries.map((i) => i.id)).then(() => {
        if (formData?.categories?.length > 0) {
          formData.categories.forEach((cat) => {
            fetchSubcategories(cat.id);
          });
        }
      });
    }
  }, [formData]);

  // Fetch categories by industry ids
  const fetchCategories = async (industryIds) => {
    try {
      const allCategories = [];
      for (const id of industryIds) {
        const res = await axiosInstance.get(`category?type=2&parent_id=${id}`);
        const options = res.data.response.map((cat) => ({
          value: cat.id,
          label: cat.title,
        }));
        allCategories.push(...options);
      }
      setCategoryOptions(allCategories);
      return allCategories;
    } catch (err) {
      console.error("Error fetching categories:", err);
      setCategoryOptions([]);
      return [];
    }
  };

  // Fetch subcategories by category id
  const fetchSubcategories = async (parentId) => {
    try {
      const res = await axiosInstance.get(
        `category?type=3&parent_id=${parentId}`
      );
      const options = res.data.response.map((sub) => ({
        value: sub.id,
        label: sub.title,
      }));
      setSubcategoryOptions((prev) => ({ ...prev, [parentId]: options }));
    } catch (err) {
      console.error("Error fetching subcategories:", err);
    }
  };

  // Industry change
  const handleIndustryChange = async (options) => {
    const industries =
      options?.map((opt) => ({
        id: opt.value,
        title: opt.label,
      })) || [];
    setSelectedIndustries(industries);
    formik.setFieldValue("industries", industries);

    if (industries.length > 0) {
      const newCategoryOptions = await fetchCategories(industries.map((i) => i.id));
      
      const validCategoryIds = new Set(newCategoryOptions.map((opt) => opt.value));
      const retainedCategories = selectedCategories.filter((cat) => validCategoryIds.has(cat.id));
      
      setSelectedCategories(retainedCategories);
      formik.setFieldValue("categories", retainedCategories);

      const retainedSubcatOptions = {};
      for (const [key, value] of Object.entries(subcategoryOptions)) {
        if (validCategoryIds.has(Number(key)) || validCategoryIds.has(String(key))) {
          retainedSubcatOptions[key] = value;
        }
      }
      setSubcategoryOptions(retainedSubcatOptions);
    } else {
      setSelectedCategories([]);
      setSubcategoryOptions({});
      setCategoryOptions([]);
      formik.setFieldValue("categories", []);
    }
  };

  // Category change
  const handleCategoryChange = (options) => {
    const categories =
      options?.map((opt) => {
        const existingCat = selectedCategories.find((c) => c.id === opt.value);
        if (existingCat) {
          return existingCat;
        } else {
          fetchSubcategories(opt.value);
          return {
            id: opt.value,
            title: opt.label,
            sub_categories: [],
          };
        }
      }) || [];
    setSelectedCategories(categories);
    formik.setFieldValue("categories", categories);
  };

  // Subcategory change
  const handleSubcategoryChange = (selectedOptions, index) => {
    const updated = [...selectedCategories];
    updated[index] = { ...updated[index] };
    updated[index].sub_categories = selectedOptions.map((s) => ({
      id: s.value,
      title: s.label,
    }));
    setSelectedCategories(updated);
    formik.setFieldValue("categories", updated);
  };

  // ✅ Utility: get all category + subcategory IDs
  const getCategoryIds = (categories) => {
    if (!Array.isArray(categories)) return "";
    const ids = categories.flatMap((cat) => [
      cat.id,
      ...(Array.isArray(cat.sub_categories)
        ? cat.sub_categories.map((sub) => sub.id)
        : []),
    ]);
    return ids.join(",");
  };

  // ✅ Fetch skills when categories change
  useEffect(() => {
    if (selectedCategories.length) {
      const categoryIds = getCategoryIds(selectedCategories);
      axiosInstance
        .get(`category?type=6&category_id=${categoryIds}`)
        .then((res) => {
          if (res?.data) {
            setAllSkills(res.data?.response);
            setPopularSkills(res.data?.response);
          }
        })
        .catch((err) => {
          console.error("Error fetching skills:", err);
        });
    } else {
      setAllSkills([]);
      setPopularSkills([]);
    }
  }, [selectedCategories]);

  // ✅ Dropdown selection with duplicate prevention
  const handleLanguageChange = (selectedOption) => {
    if (isDuplicateSkill(selectedOption.value, selectedSkills)) {
      urtoast("Duplicate Skill Not allowed.", 2);
      return;
    }
    const newSkill = { id: selectedOption.value, title: selectedOption.label };
    const updatedSkills = [...selectedSkills, newSkill];
    setSelectedSkills(updatedSkills);
    if (updatedSkills.length >= 3) setSkillValidation(false);
    setSelectSkills(null);
  };

  // ✅ Popular skill addition with duplicate prevention
  const handleAddPopularSkill = (skill) => {
    if (isDuplicateSkill(skill.id, selectedSkills)) {
      urtoast("Duplicate Skill Not allowed.", 2);
      return;
    }
    const updatedSkills = [...selectedSkills, skill];
    setSelectedSkills(updatedSkills);
    if (updatedSkills.length >= 3) setSkillValidation(false);
  };

  // ✅ Manual skill addition with duplicate prevention
  const handleAddManualSkill = () => {
    const trimmedSkill = manualSkill.trim();
    if (!trimmedSkill) return;

    const duplicate =
      isDuplicateSkill(trimmedSkill, selectedSkills) ||
      (Array.isArray(allSkills) &&
        allSkills.some(
          (skill) => skill.title.toLowerCase() === trimmedSkill.toLowerCase()
        ));

    if (duplicate) {
      urtoast("Duplicate Skill Not allowed.", 2);
      return;
    }

    const newSkill = { id: trimmedSkill, title: trimmedSkill };
    const updatedSkills = [...selectedSkills, newSkill];
    setSelectedSkills(updatedSkills);
    if (updatedSkills.length >= 3) setSkillValidation(false);
    setManualSkill("");
    setAddmanual(false);
  };

  const handleDeleteLanguage = (id) => {
    const updatedSkills = selectedSkills.filter((skill) => skill.id !== id);
    setSelectedSkills(updatedSkills);
  };

  // Formik setup
  const formik = useFormik({
    initialValues: {
      industries: selectedIndustries,
      categories: selectedCategories,
    },
    validationSchema: Yup.object().shape({
      industries: Yup.array().min(1, "Industry is required"),
      categories: Yup.array().min(1, "Category is required"),
    }),
    onSubmit: () => {
      const noIndustry = selectedIndustries.length === 0;
      const noCategory = selectedCategories.length === 0;

      if (noIndustry || noCategory || selectedSkills.length < 3) {
        setValidation(noIndustry || noCategory);
        setSkillValidation(selectedSkills.length < 3);
        return;
      }

      const payload = {
        type: "industry_category_skills",
        industries: selectedIndustries.map((i) => ({ id: i.id })),
        categories: selectedCategories.map((c) => ({
          id: c.id,
          sub_categories: c.sub_categories.map((s) => ({ id: s.id })),
        })),
        skills: selectedSkills,
      };
      console.log(payload, "payload");

      if (edittype === 1) {
        dispatch(updateProfile(payload));
        setCatsubcat(false);
      } else {
        setFormData({
          ...formData,
          industries: selectedIndustries,
          categories: selectedCategories,
          skills: selectedSkills,
        });
        setCatsubcat(false);
      }
    },
  });

  return (
    <>
      <button onClick={() => setCatsubcat(false)} className="btn close-button">
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt="close"
        />
      </button>

      <ModalBody>
        <h4>Edit Industry, Category & Subcategory</h4>
        <form onSubmit={formik.handleSubmit}>
          {/* Industry */}
          <div className="form-group">
            <label>Select Industries</label>
            <ReactSelect
              options={
                Array.isArray(industrylist)
                  ? industrylist.map((i) => ({ value: i.id, label: i.title }))
                  : []
              }
              isMulti
              placeholder="Select Industries"
              value={selectedIndustries.map((i) => ({
                value: i.id,
                label: i.title,
              }))}
              onChange={handleIndustryChange}
            />
          </div>

          {/* Category */}
          {selectedIndustries.length > 0 && (
            <div className="form-group">
              <label>Select Categories</label>
              <ReactSelect
                options={categoryOptions}
                isMulti
                placeholder="Select Categories"
                value={selectedCategories.map((c) => ({
                  value: c.id,
                  label: c.title,
                }))}
                onChange={handleCategoryChange}
              />
            </div>
          )}

          {/* Subcategory (optional) */}
          {selectedCategories.length > 0 &&
            selectedCategories.map((cat, idx) => (
              <div key={cat.id} className="row modal-edit-row mb-2 align-items-center">
                <div className="col-md-4">
                  <label className="mb-0">{cat.title}</label>
                </div>
                <div className="col-md-8">
                  <ReactSelect
                    options={subcategoryOptions[cat.id] || []}
                    isMulti
                    value={cat.sub_categories.map((s) => ({
                      value: s.id,
                      label: s.title,
                    }))}
                    placeholder="Select Subcategories"
                    onChange={(opts) => handleSubcategoryChange(opts, idx)}
                  />
                </div>
              </div>
            ))}
        </form>

        <hr />
        <h4 className="mt-4">Edit Competencies</h4>
        <div className="form-group">
          <label className="label">Search or add competencies</label>

          <ReactSelect
            options={
              Array.isArray(allSkills)
                ? allSkills
                  .filter(
                    (skill) => !isDuplicateSkill(skill.id, selectedSkills)
                  )
                  .map((skill) => ({ value: skill.id, label: skill.title }))
                : []
            }
            placeholder="Select competencies"
            isClearable={true}
            value={selectSkills}
            onChange={(option) => option && handleLanguageChange(option)}
          />

          <p>Add up to 5 competencies for best results</p>

          <button
            className="add-plus btn"
            onClick={() => setAddmanual(true)}
          >
            + Add competencies Manually
          </button>
          {addmanual && (
            <div className="manualskill-input mb-3">
              <input
                type="text"
                value={manualSkill}
                onChange={(e) => setManualSkill(e.target.value)}
                placeholder="Type a competencies"
                className="form-control"
                style={{ width: "65%" }}
                onKeyDown={(e) => {
                  if (e.key == "Enter") {
                    e.preventDefault();
                    handleAddManualSkill();
                  }
                }}
              />
              <button type="button" onClick={handleAddManualSkill}>
                Add
              </button>
              <button type="button" onClick={() => setAddmanual(false)}>
                Close
              </button>
            </div>
          )}

          <div className="add-skills">
            {selectedSkills.map((skill, index) => (
              <div key={index} onClick={() => handleDeleteLanguage(skill.id)}>
                <p>
                  {decodeHtml(skill.title)} <span>x</span>
                </p>
              </div>
            ))}
          </div>

          <div className="popular-skill">
            <h5 className="mt-2">Popular competencies based on your designation</h5>
            <div className="add-skills">
              {popularSkills
                .filter((skill) => !isDuplicateSkill(skill.id, selectedSkills))
                .map((skill, index) => (
                  <div key={index} onClick={() => handleAddPopularSkill(skill)}>
                    <p className="select-deactive-skill">
                      {decodeHtml(skill.title)} <span>+</span>
                    </p>
                  </div>
                ))}
            </div>
          </div>
        </div>

      </ModalBody>

      {validation && (
        <p style={{ color: "red", paddingLeft: "15px" }}>
          Please select at least 1 industry and 1 category
        </p>
      )}
      {skillValidation && (
        <p style={{ color: "red", paddingLeft: "15px" }}>
          Please add at least 3 competencies
        </p>
      )}

      <div className="modal-footer mt-3">
        <button
          className="btn"
          onClick={() => {
            setValidation(true);
            formik.handleSubmit();
          }}
        >
          Save
        </button>
      </div>
    </>
  );
};

export default ProfileModelCategoerySubcategory;

// IDE bust cache 2
